// extracted by mini-css-extract-plugin
export default {"heading":"Dashboard_heading__E-M8o","loader":"Dashboard_loader__5v+gl","MainContainer":"Dashboard_MainContainer__-l2v1"};